export * from './group-permissions.model';
export * from './group-permissions.module';
export * from './group-permissions.seed';
export * from './group-permissions.transformers';
export * from './group-permissions.types';
